import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import { FILTER_CONSTS } from '../../../constants/TopFilterConstants';
import { CardMenuChangePlaylistThumbnailOption, MobileMenuChangePlaylistThumbnailOption, usePlaylist, useUserOwnsPlaylist } from '../../../features/savedItems';
import { usePlaylistProgress } from '../../../features/userProgress';
import styled, { theme, useMediaQuery } from '../../../utils/Styling';
import { FormattedMessage, FormattedReactMessage } from '../../I18n';
import MobileNestedMenu from '../../Modals/FullScreenModal/MobileNestedMenu';
const Message = styled(FormattedReactMessage).withConfig({
  displayName: "PlaylistThumbnailBlank__Message",
  componentId: "sc-19ufqx9-0"
})(["color:", ";padding:0 20%;text-align:center;"], theme.colors.SLINKY);
const Obscurer = styled(UIFlex).withConfig({
  displayName: "PlaylistThumbnailBlank__Obscurer",
  componentId: "sc-19ufqx9-1"
})(["", ";"], ({
  $isActive
}) => $isActive ? `
      height: 100%;
      width: 100%;
      transition: 0.3s ease background;
      & > * {
        opacity: 0;
      }
      a {
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }

      &:hover, &.menu-open {
        background-color: rgba(0, 0, 0, 0.65);
        & > * {
          opacity: 1;
        }
      }` : ``);

const PlaylistThumbnailBlankChangeButton = ({
  hasThumbnail,
  onClick,
  use = 'blue'
}) => /*#__PURE__*/_jsxs(UILink, {
  onClick: onClick,
  use: use,
  children: [/*#__PURE__*/_jsx(UIIcon, {
    name: hasThumbnail ? 'edit' : 'add',
    size: 'small'
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: hasThumbnail ? 'learningCenter.savedItems.playlistDetails.thumbnailBlankChangeThumbnail' : 'learningCenter.savedItems.playlistDetails.thumbnailBlankChooseThumbnail'
  })]
});

const PlaylistThumbnailBlank = ({
  playlistId,
  onAddContent
}) => {
  const {
    playlist
  } = usePlaylist(playlistId);
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  const {
    isMobile
  } = useMediaQuery();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    playlistProgress
  } = usePlaylistProgress(playlistId);
  if (!playlist || !userIsOwner) return null;
  const completed = playlistProgress && playlistProgress.status && playlistProgress.status === FILTER_CONSTS.STATUSES.COMPLETED;

  if (!playlist.itemsCount) {
    if (playlist.thumbnailRectangleUrl) return null;
    return /*#__PURE__*/_jsx(Message, {
      message: "learningCenter.savedItems.playlistDetails.thumbnailBlankNoItems",
      options: {
        action: /*#__PURE__*/_jsx(UILink, {
          onClick: onAddContent,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.savedItems.playlistDetails.thumbnailBlankAddContent"
          })
        })
      }
    });
  }

  if (isMobile) {
    if (playlist.thumbnailRectangleUrl) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PlaylistThumbnailBlankChangeButton, {
        hasThumbnail: !!playlist.thumbnailRectangleUrl,
        onClick: () => setIsMenuOpen(true),
        use: completed ? 'on-dark' : 'blue'
      }), isMenuOpen && /*#__PURE__*/_jsx(MobileNestedMenu, {
        indented: false,
        open: true,
        setIsOpen: openState => setIsMenuOpen(openState),
        useBackText: true,
        useSidePanel: true,
        children: /*#__PURE__*/_jsx(MobileMenuChangePlaylistThumbnailOption, {
          onItemClick: () => setIsMenuOpen(false),
          playlistId: playlistId
        })
      })]
    });
  }

  const isObscurerActive = !!playlist.thumbnailRectangleUrl;
  return /*#__PURE__*/_jsx(Obscurer, {
    $isActive: isObscurerActive,
    align: "center",
    className: isMenuOpen ? 'menu-open' : '',
    justify: "center",
    children: /*#__PURE__*/_jsx(CardMenuChangePlaylistThumbnailOption, {
      onOpenChange: isOpen => setIsMenuOpen(isOpen),
      playlistId: playlistId,
      render: handleClick => /*#__PURE__*/_jsx(PlaylistThumbnailBlankChangeButton, {
        hasThumbnail: !!playlist.thumbnailRectangleUrl,
        onClick: handleClick,
        use: isObscurerActive || completed ? 'on-dark' : 'blue'
      })
    })
  });
};

export default PlaylistThumbnailBlank;